import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { updateCompanyUser2, companyUserUpdated, resetPasswordSendSms, resetPasswordSendEmail } from 'actions/company';

import { Link } from 'react-router';
import NavBarConfig from 'components/NavBarConfig';
import CompanyUserUpdate from 'components/companyUser/CompanyUserUpdate';
import { FORM_ERROR } from 'final-form';

const messages = defineMessages({
  BACK: {
    id: 'CompanyUserUpdatePage.BACK',
    defaultMessage: 'Zurück',
  },
  EDIT_USER: {
    id: 'CompanyUserUpdatePage.EDIT_USER',
    defaultMessage: 'Benutzer bearbeiten',
  },
  BUTTON_RESET_PASSWORT_SMS: {
    id: 'CompanyUserSinglePage.BUTTON_RESET_PASSWORT_SMS',
    defaultMessage: 'Passwort per SMS zurücksetzen',
  },
  BUTTON_RESET_PASSWORT_EMAIL: {
    id: 'CompanyUserSinglePage.BUTTON_RESET_PASSWORT_EMAIL',
    defaultMessage: 'Passwort per E-mail zurücksetzen',
  },
  DELETE_USER: {
    id: 'CompanyUserSinglePage.DELETE_USER',
    defaultMessage: 'Benutzer löschen',
  },
});

function CompanyUserUpdatePage({
  user,
  company,
  companyUser,
  onSubmit,
  onResetPasswordSendSms,
  onResetPasswordSendEmail,
  routes,
  intl: { formatMessage },
}) {
  if (!companyUser) { return null; }

  const isSelf = user && companyUser && user.id === companyUser.user_id;

  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <NavBarConfig updatePage currentRouteName={routes[routes.length - 1].name} />
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '700px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Link to={`/company/${company.id}/user/`} onMouseDown={e => e.preventDefault()} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none' }}>
              <i className="fa fa-arrow-left" />
            </Link>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
              {formatMessage(messages.EDIT_USER)}
            </h2>
          </div>
          
          {/* Main Card */}
          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '16px', border: '1px solid var(--panel-border)', boxShadow: '0 4px 6px -1px var(--panel-shadow)', padding: '32px' }}>
          <CompanyUserUpdate
            is_admin={user.is_admin}
            isSelf={isSelf}
            onSubmit={onSubmit}
            initialValues={{
              name: companyUser.user.name,
              email: companyUser.user.email,
              phone: companyUser.user.phone,
              is_admin: companyUser.is_admin,
              is_owner: companyUser.is_owner,
              is_inactive: companyUser.is_inactive,
            }}
          />

          {/* Combined user page bottom actions */}
          {user.is_admin || !companyUser.is_owner ? (
            <div style={{ borderTop: '1px solid var(--panel-border)', paddingTop: '24px', marginTop: '40px' }}>
              {companyUser.user.phone ? (
                <button
                  className="lh-btn lh-btn-default lh-btn-block"
                  type="button"
                  style={{ marginBottom: '12px' }}
                  onClick={onResetPasswordSendSms}
                >
                  <span className="fa fa-mobile" /> {formatMessage(messages.BUTTON_RESET_PASSWORT_SMS)}
                </button>
              ) : null}
              {companyUser.user.email ? (
                <button
                  className="lh-btn lh-btn-default lh-btn-block"
                  type="button"
                  style={{ marginBottom: '12px' }}
                  onClick={onResetPasswordSendEmail}
                >
                  <span className="fa fa-envelope-o" /> {formatMessage(messages.BUTTON_RESET_PASSWORT_EMAIL)}
                </button>
              ) : null}
              <Link
                className="lh-btn lh-btn-block"
                style={{ marginTop: '24px', backgroundColor: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: '1px solid rgba(239, 68, 68, 0.2)' }}
                to={`/company/${companyUser.company_id}/user/${companyUser.user_id}/delete/`}
              >
                <span className="fa fa-trash" />
                {' '}{formatMessage(messages.DELETE_USER)}
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  </div>
  );
}

export default connect(
  state => ({
    user: state.auth.user
  }),
  (dispatch, props) => ({
    onSubmit: async formData => {
      const data = await updateCompanyUser2(props.params.companyId, props.params.userId, {
        ...formData,
        email: formData.email || undefined,
        phone: formData.phone || undefined,
      });
      if (data.response) {
        const companyUser = data.response;
        dispatch(companyUserUpdated(companyUser));
        dispatch(push(`/company/${props.params.companyId}/user/`));
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
    },
    onResetPasswordSendSms: () => resetPasswordSendSms(props.params.companyId, props.params.userId).then(() => {
      const { companyId, userId } = props.params;
      dispatch(push(`/company/${companyId}/user/${userId}/success/`));
    }),
    onResetPasswordSendEmail: () => resetPasswordSendEmail(props.params.companyId, props.params.userId).then(() => {
      const { companyId, userId } = props.params;
      dispatch(push(`/company/${companyId}/user/${userId}/success/`));
    }),
  })
)(injectIntl(CompanyUserUpdatePage));
